import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, X } from 'lucide-react';
import { MENTORSHIP_CHECKOUT_URL, BUNDLE_CHECKOUT_URL } from '../constants/site';

const GUARDED = [MENTORSHIP_CHECKOUT_URL, BUNDLE_CHECKOUT_URL];

// Intercepts clicks on Mentorship / Complete Path Stripe links and requires the early-start consent first
export const CheckoutConsentGuard = () => {
  const [target, setTarget] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest?.('a[href]');
      if (!a || !GUARDED.some((u) => a.href.startsWith(u))) return;
      e.preventDefault();
      setChecked(false);
      setTarget(a.href);
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  if (!target) return null;

  const proceed = () => {
    window.open(target, '_blank', 'noopener,noreferrer');
    setTarget(null);
  };

  return (
    <div className="fixed inset-0 z-[2147483000] flex items-center justify-center bg-black/60 px-4" data-testid="checkout-consent-modal">
      <div className="relative bg-[#FDFBF7] max-w-lg w-full p-8 shadow-2xl">
        <button onClick={() => setTarget(null)} className="absolute top-4 right-4 text-[#5A5A5A] hover:text-[#0F0F0F]" aria-label="Close" data-testid="checkout-consent-close">
          <X size={18} />
        </button>
        <span className="overline inline-block mb-4">Before payment</span>
        <label className="flex items-start gap-3 text-sm text-[#1A1A1A] leading-relaxed cursor-pointer">
          <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} className="mt-1 accent-[#C5A880]" data-testid="checkout-consent-checkbox" />
          <span>
            I have read and accept the <Link to="/legal/terms" target="_blank" className="underline hover:text-[#C5A880]">Terms of Sale</Link>. I expressly request that the service start before the end of the 14-day withdrawal period, and I acknowledge that I will owe the proportion of the service already provided if I withdraw after it has started.
          </span>
        </label>
        <button onClick={proceed} disabled={!checked} className="btn-primary inline-flex items-center gap-2 mt-8 disabled:opacity-40 disabled:cursor-not-allowed" data-testid="checkout-consent-continue">
          Continue to payment <ArrowRight size={14} />
        </button>
      </div>
    </div>
  );
};
